import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { BodyTextM, cs, HeadingM, MuiImage } from "@repo/ui";
import FirstStepImage from "@repo/ui/assets/images/1st-step.png";
import { Form } from "formik";
import { type FC } from "react";
import {
	MarketingGdprTextWithLink,
	MarketingTextWithPartnerLink,
} from "../../../pages/profile/marketing";
import RadioInput from "../../Form/Input/Radio";
import { RadioGroup } from "../../Form/Input/Radio/RadioGroup";

const AgreementForm: FC = () => {
	return (
		<Form
			noValidate // you need this to turn off browser default validation, thank this, all errors show up at once
		>
			<HeadingM>{cs.profile.secondStep.header}</HeadingM>
			<Stack spacing={5}>
				<BodyTextM>{cs.profile.secondStep.content}</BodyTextM>
				<Stack>
					<MuiImage
						sx={{
							margin: "auto"
						}}
						src={FirstStepImage}
					/>
				</Stack>
				<Paper
					elevation={16}
					sx={{
						p: 4,
					}}
				>
					<Stack spacing={5}>
						<MarketingTextWithPartnerLink />
						<MarketingGdprTextWithLink />
						<RadioGroup name="agreement">
							<RadioInput
								name="agreement"
								value={true}
								id="agree"
								label="Souhlasím"
							/>
							<RadioInput
								name="agreement"
								value={false}
								id="disagree"
								label="Nesouhlasím"
							/>
						</RadioGroup>
					</Stack>
				</Paper>
			</Stack>
		</Form>
	);
};

export default AgreementForm;
